import EventEmitter from 'eventemitter3';
import * as PIXI from 'pixi.js';

export interface SelectEvent {
  index: number;
}

function rgb(r: number, g: number, b: number) {
  // eslint-disable-next-line no-bitwise
  return (r << 16) + (g << 8) + b;
}

export class PixiRadioButton extends EventEmitter<{
  select: [SelectEvent];
}> {
  private contaiern: PIXI.Container;
  private items: PIXI.Sprite[] = [];
  private values = [
    'x1/2',
    'x1',
    'x2',
    'x4',
  ];

  private currentIndex = 1;
  private selectOverTexture = PIXI.Texture.from('/img/radio_select_over.png');
  private selecTexture = PIXI.Texture.from('/img/radio_select.png');
  private overtexture = PIXI.Texture.from('/img/radio_over.png');
  private normalTexure = PIXI.Texture.from('/img/radio.png');

  constructor() {
    super();
    this.contaiern = new PIXI.Container();

    const textOption = new PIXI.TextStyle({
      fill: [rgb(99, 255, 255)],
      fontSize: 16,
    });

    this.values.forEach((v, i) => {
      const sprite = new PIXI.Sprite(i === 1 ? this.selecTexture : this.normalTexure);

      sprite.position = new PIXI.Point(0, 19 * i);
      const text = new PIXI.Text(v, textOption);
      text.position = new PIXI.Point(20, 2);
      sprite.addChild(text);
      this.items.push(sprite);
      this.contaiern.addChild(sprite);

      sprite.interactive = true;
      sprite.buttonMode = true;
      sprite.on('pointerover', () => {
        sprite.texture = this.currentIndex === i ? this.selectOverTexture : this.overtexture;
      });
      sprite.on('pointerout', () => {
        sprite.texture = this.currentIndex === i ? this.selecTexture : this.normalTexure;
      });
      sprite.on('pointerdown', () => {
        this.items[this.currentIndex].texture = this.normalTexure;
        this.currentIndex = i;
        sprite.texture = this.selectOverTexture;
        this.emit('select', { index: this.currentIndex });
      });
    });
  }

  public getContainer() {
    return this.contaiern;
  }
}
